import { render, staticRenderFns } from "./DashboardSales.vue?vue&type=template&id=1a83f66e&scoped=true&"
var script = {}
import style0 from "./DashboardSales.vue?vue&type=style&index=0&id=1a83f66e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a83f66e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/dashboard/DashboardSales.vue
// module id = 970
// module chunks = 0